<div class="cart-vcash-page" *ngIf="cartItems.length > 0; else emptyCart">

  <!-- TOP AREA -->
  <section class="cart-top">
    <div class="cart-appbar">
      <button class="cart-appbar-btn" type="button" (click)="goBack()">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </button>

      <h1 class="cart-appbar-title"> {{ "Cart" | transloco }}</h1>

      <div class="cart-appbar-count">
        {{ getCartQuantityTotal() }}
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="cart-content">

    <!-- OVERVIEW CARD -->
    <section class="cart-overview-card">
      <div class="cart-overview-top">
        <div class="cart-overview-main">
          <span class="cart-overline">{{ "total" | transloco }}</span>
          <h2>
            {{ getTotal() }} {{ "egpe" | transloco }}
          </h2>

          <p class="cart-old-total" *ngIf="getDiscountTotal() != getTotal()">
            {{ getDiscountTotal() }} {{ "egpe" | transloco }}
          </p>
        </div>

        <div class="cart-overview-side">
          <span> {{ "Items" | transloco }}</span>
          <strong>{{ getCartQuantityTotal() }}</strong>
        </div>
      </div>

      <div class="cart-overview-bottom">
        <button class="cart-mini-action" (click)="clearCart()">
          <img src="/assets/e-commerce/icons/44.webp" alt="clear" />
          <span>{{ "clearcart" | transloco }}</span>
        </button>

        <div class="cart-mini-action cart-mini-action--static">
          <img src="/assets/e-commerce/icons/66.webp" alt="total" />
          <span>{{ getTotal() }} {{ "egpe" | transloco }}</span>
        </div>
      </div>
    </section>

    <!-- ITEMS -->
    <section class="cart-items-section">
      <div class="cart-section-header">
        <h3>{{ "Cart Items" | transloco }}</h3>
      </div>

      <div class="cart-list">

        <div class="cart-card" *ngFor="let item of cartItems">

          <!-- BUNDLE -->
          <div *ngIf="item.type === 'bundle'; else normalProduct" class="cart-product-row">

            <img class="cart-product-image pointer" (click)="productDetails(item.product)"
              [lazyLoad]="fixImage(item.product.image)" alt="bundle" />

            <div class="cart-product-content">
              <h4 class="cart-product-title">
                {{ isAr ? item.product.name_ar : item.product.name_en }}
                <span class="bundle-badge">{{ "deal" | transloco }}</span>
              </h4>

              <p class="cart-product-desc">
                {{ isAr ? item.product.description_ar : item.product.description_en }}
              </p>

              <ul class="cart-bundle-list">
                <li *ngFor="let sub of item.items">
                  ×{{ sub.quantity * item.quantity }}
                  {{ isAr ? sub.stock.name_ar : sub.stock.name_en }}
                </li>
              </ul>

              <div class="cart-bottom-row">
                <div class="cart-price-block">
                  <span class="cart-new-price">
                    {{ item.product.priceb }} {{ "egpe" | transloco }}
                  </span>

                  <span class="cart-old-price" *ngIf="calcDis(item.product.priceb, item.product.pricec) != 0">
                    {{ item.product.pricec }} {{ "egpe" | transloco }}
                  </span>
                </div>

                <div class="cart-qty-box">
                  <button (click)="decreaseQuantity(item)">−</button>
                  <span>{{ item.quantity }}</span>
                  <button (click)="increaseQuantity(item)">+</button>
                </div>
              </div>
            </div>
          </div>

          <!-- NORMAL PRODUCT -->
          <ng-template #normalProduct>
            <div class="cart-product-row">

              <img class="cart-product-image pointer" (click)="productDetails(item.product)"
                [defaultImage]="'/assets/imageloading.gif'" [lazyLoad]="fixImage(item.product.image)"
                [errorImage]="'/assets/noproduct.png'" alt="product" />

              <div class="cart-product-content">
                <h4 class="cart-product-title">
                  {{ isAr ? item.product.name_ar : item.product.name_en }}

                  <span *ngIf="item.product.is_free_reward" class="reward-badge">
                    <img class="reward-badge-img" src="/assets/e-commerce/icons/77.webp" alt="reward" />
                  </span>
                </h4>

                <div class="cart-bottom-row">
                  <div class="cart-price-block">
                    <span class="cart-new-price">
                      @if(item.product.is_daily_offer){
                      {{ item.product.affiliationprice }} {{ "egpe" | transloco }}
                      }
                      @else{
                      {{ item.product.pricec }} {{ "egpe" | transloco }}
                      }
                    </span>

                    <span class="cart-old-price" *ngIf="calcDis(item.product.pricec, item.product.priced) != 0">
                      {{ item.product.priced }} {{ "egpe" | transloco }}
                    </span>
                  </div>

                  <div class="cart-qty-box">
                    <button (click)="decreaseQuantity(item)">−</button>
                    <span>{{ item.quantity }}</span>
                    <button (click)="increaseQuantity(item)">+</button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

        </div>
      </div>
      <div class="cart-sticky-bar" style="margin-bottom:100px ;">
        <div class="cart-sticky-total">
          <span>{{ "total" | transloco }}</span>
          <strong>{{ getTotal() }} {{ "egpe" | transloco }}</strong>
        </div>

        <button class="cart-sticky-checkout" [class.disabled-btn]="isOnlyWheelRewardCart()" (click)="handleCheckout()">
          {{ "checkout" | transloco }}
        </button>
      </div>
    </section>
  </div>

  <!-- STICKY CHECKOUT -->

</div>

<!-- EMPTY CART -->
<ng-template #emptyCart>
  <app-emptycart></app-emptycart>
</ng-template>
